<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div
        v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
      >
        <mini-statistics-card
          :title="this.currUnpiadAm"
          :value="this.moneyFormat(currentUnpaidAmount)"
          :percentage="{
            value: '+505%',
            color: 'text-success',
          }"
          :icon="{
            component: 'ni ni-money-coins',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          :title="this.$t('kids.kid_s')"
          :value="this.kids.length"
          :percentage="{
            value: '+3%',
            color: 'text-success',
          }"
          :icon="{
            component: ' ni ni-world',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          :title="this.$t('kids.deletedKids')"
          :value="this.deleted_kids"
          :percentage="{
            value: '-2%',
            color: 'text-danger',
          }"
          :icon="{
            component: 'ni ni-paper-diploma',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>
      <div
        v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
        class="col-xl-3 col-sm-6 mb-xl-0"
      >
        <mini-statistics-card
          :title="
            this.$t('payments.fullDebt') +
            ' (' +
            this.$t('global.currency') +
            ')'
          "
          :value="this.moneyFormat(total_sum_prices)"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-cart', background: iconBackground }"
          direction-reverse
        />
      </div>
    </div>

    <div class="mt-4 row">
      <div class="mb-4 col-lg-5 mb-lg-0">
        <div class="card z-index-2">
          <div class="p-3 card-body">
            <reports-bar-chart
              v-if="dataLoaded"
              id="chart-bar"
              :title="this.$t('kids.numberBySubcourses')"
              description=""
              :chart="{
                labels: this.subcourses_title,
                datasets: {
                  label: this.$t('kids.kid_s'),
                  data: this.kids_count,
                },
              }"
              :items="[
                {
                  icon: {
                    color: 'primary',
                    component: faUsers,
                  },
                  label: this.$t('kids.kid_s'),
                  progress: { content: this.kids.length, percentage: 100 },
                },
                {
                  icon: { color: 'info', component: faHandPointer },
                  label: this.$t('kids.deletedKids'),
                  progress: { content: this.deleted_kids, percentage: 100 },
                },
                {
                  icon: { color: 'warning', component: faCreditCard },
                  label: 'Sales',
                  progress: { content: '435$', percentage: 100 },
                },
                {
                  icon: { color: 'danger', component: faScrewdriverWrench },
                  label: 'Items',
                  progress: { content: '43', percentage: 100 },
                },
              ]"
            />
            <!-- <reports-bar-chart
              v-if="dataLoaded"
              id="chart-bar"
              :title="this.$t('kids.numberByMonths')"
              description=""
              :chart="{
                labels: this.months,
                datasets: {
                  label: this.$t('kids.kid_s'),
                  data: this.kidNumber,
                },
              }"
              :items="[
                {
                  icon: {
                    color: 'primary',
                    component: faUsers,
                  },
                  label: this.$t('kids.kid_s'),
                  progress: { content: this.kids.length, percentage: 100 },
                },
                {
                  icon: { color: 'info', component: faHandPointer },
                  label: this.$t('kids.deletedKids'),
                  progress: { content: this.deleted_kids, percentage: 100 },
                },
                {
                  icon: { color: 'warning', component: faCreditCard },
                  label: 'Sales',
                  progress: { content: '435$', percentage: 100 },
                },
                {
                  icon: { color: 'danger', component: faScrewdriverWrench },
                  label: 'Items',
                  progress: { content: '43', percentage: 100 },
                },
              ]"
            /> -->
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <!-- line chart -->
        <div class="card z-index-2 py-3 mt-1" v-if="dataLoaded">
          <gradient-line-chart
            id="chart-line"
            :title="this.$t('kids.kidStatistic')"
            description=""
            :chart="{
              labels: this.kids_by_months,
              datasets: [
                {
                  label: 'Ukupan br. polaznika',
                  data: this.kids_number_by_months,
                },
                {
                  label: 'Ispisanih polaznika',
                  data: this.inactive_kids_by_months,
                },
                /* { label: 'Mobile Apps', data: [5, 4, 3, 2, 5, 2, 4, 7, 5, 1], }, {
          label: 'Websites', data: [3, 9, 4, 1, 2, 2, 4, 2, 4, 5], }, */
              ],
            }"
          />
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-lg-8 col-md-6 mb-md-0 mb-4">
        <projects-card :kids="kids" />
      </div>
      <div class="col-lg-4 col-md-6">
        <timeline-list
          class="h-100"
          title="Orders overview"
          description="<i class='fa fa-arrow-up text-success' aria-hidden='true'></i>
        <span class='font-weight-bold'>24%</span> this month"
        >
          <timeline-item
            color="success"
            icon="bell-55"
            title="$2400 Design changes"
            date-time="22 DEC 7:20 PM"
          />
          <TimelineItem
            color="danger"
            icon="html5"
            title="New order #1832412"
            date-time="21 DEC 11 PM"
          />
          <TimelineItem
            color="info"
            icon="cart"
            title="Server payments for April"
            date-time="21 DEC 9:34 PM"
          />
          <TimelineItem
            color="warning"
            icon="credit-card"
            title="New card added for order #4395133"
            date-time="20 DEC 2:20 AM"
          />
          <TimelineItem
            color="primary"
            icon="key-25"
            title="Unlock packages for development"
            date-time="18 DEC 4:54 AM"
          />
          <TimelineItem
            color="info"
            icon="check-bold"
            title="Notifications unread"
            date-time="15 DEC"
          />
        </timeline-list>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import TimelineList from "./components/TimelineList.vue";
import TimelineItem from "./components/TimelineItem.vue";
import ProjectsCard from "./components/ProjectsCard.vue";
import US from "../assets/img/icons/flags/US.png";
import DE from "../assets/img/icons/flags/DE.png";
import GB from "../assets/img/icons/flags/GB.png";
import BR from "../assets/img/icons/flags/BR.png";
import {
  faHandPointer,
  faUsers,
  faCreditCard,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
export default {
  name: "dashboard-default",
  components: {
    MiniStatisticsCard,
    ReportsBarChart,
    GradientLineChart,
    ProjectsCard,
    TimelineList,
    TimelineItem,
  },
  data() {
    return {
      iconBackground: "bg-gradient-success",
      faCreditCard,
      faScrewdriverWrench,
      faUsers,
      faHandPointer,
      sales: {
        us: {
          country: "United States",
          sales: 2500,
          value: "$230,900",
          bounce: "29.9%",
          flag: US,
        },
        germany: {
          country: "Germany",
          sales: "3.900",
          value: "$440,000",
          bounce: "40.22%",
          flag: DE,
        },
        britain: {
          country: "Great Britain",
          sales: "1.400",
          value: "$190,700",
          bounce: "23.44%",
          flag: GB,
        },
        brasil: {
          country: "Brasil",
          sales: "562",
          value: "$143,960",
          bounce: "32.14%",
          flag: BR,
        },
      },
      kidNumber: [],
      months: null,
      currentUnpaidAmount: null,
      kids: [],
      deleted_kids: [],
      chart: {},
      dataLoaded: false,
      kids_by_subcourses: [],
      kidsByMonth: [],
      kids_by_months: [],
      kids_count: [],
      subcourses_title: [],
      total_sum_prices: null,
    };
  },
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
    currUnpiadAm() {
      return (
        this.$t("payments.currUnpiadAm") +
        " (" +
        this.$t("global.currency") +
        ")"
      );
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    moneyFormat(value) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    async getData() {
      const response = await axios.get("get-dashboard-data");

      this.kidNumber = response.data.kidNumber;
      this.months = Array.from(response.data.months);
      this.currentUnpaidAmount = response.data.total_debt;
      this.kids = response.data.dashboard_kids_data;
      this.deleted_kids = response.data.deleted_kids;
      this.kids_by_subcourses = response.data.kids_by_subcourses;
      this.kidsByMonth = response.data.kidsByMonth;
      this.total_sum_prices = response.data.total_sum_prices;
      this.kids_count = this.kids_by_subcourses.map(
        (subArray) => subArray.kids_count
      );
      this.kids_by_months = this.kidsByMonth.map((subArray) =>
        this.formatDate(subArray.month)
      );
      this.kids_number_by_months = this.kidsByMonth.map(
        (subArray) => subArray.total_kids
      );
      this.inactive_kids_by_months = this.kidsByMonth.map(
        (subArray) => subArray.quit_kids
      );
      this.subcourses_title = this.kids_by_subcourses.map(
        (subArray) => subArray.title
      );
      this.dataLoaded = true;
    },
    formatDate(dateString) {
      const date = new Date(`${dateString}/01`);

      const formatter = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
      });

      return formatter.format(date);
    },
  },
};
</script>
